import Vue from 'vue'
import Router from 'vue-router'
import Vuex from 'vuex';
import App from './App.vue'
import Home from './Home.vue'
import Mail from './Mail.vue'
import MailItem from './MailItem.vue'
import Aproposals from './Aproposals.vue'
import ContactHR from './ContactHR.vue'
import EditAproposalItem from './EditAproposalItem.vue'
import Lunch from './Lunch.vue'
import BootstrapVue from 'bootstrap-vue'
import VueLocalizer from 'vue-localizer'
import Timesheets from './Timesheets.vue'
import EditTimesheetItem from './EditTimesheetItem.vue'
import axios from 'axios'
import McWysiwyg from './McWysiwyg.vue';

// --- БЛОК SERVICE WORKER ---
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      console.log('SW registered');

      // Принудительно проверяем обновление при каждой загрузке
      registration.update();

      // Слушаем сообщения от Service Worker
      navigator.serviceWorker.addEventListener('message', event => {
        if (event.data && event.data.type === 'SW_UPDATED') {
          const newVersion = event.data.version;
          
          if (isMobileDevice()) {
            showUpdateNotification(newVersion, registration);
          } else {
            // Для ПК просто обновляем через секунду, чтобы дать SW завершить активацию
            console.log('PC Update detected, reloading...');
            setTimeout(() => { location.reload(); }, 1000);
          }
        }
      });
    }).catch(err => console.log('SW registration failed: ', err));
  });
}

function isMobileDevice() {
  return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
    || window.innerWidth <= 768;
}

function showUpdateNotification(version, registration) {
  // Проверка, чтобы не плодить уведомления
  if (document.getElementById('update-notification')) return;

  const updateBar = document.createElement('div');
  updateBar.id = 'update-notification';
  updateBar.innerHTML = `
    <div style="position: fixed; top: 0; left: 0; right: 0; background: #4CAF50; color: white; 
                padding: 12px; text-align: center; z-index: 10000; box-shadow: 0 2px 10px rgba(0,0,0,0.3);
                font-family: sans-serif;">
      <strong>Доступна новая версия v${version}</strong> 
      <button id="sw-update-btn" style="margin-left: 15px; background: gold; border: none; 
                padding: 7px 15px; border-radius: 4px; cursor: pointer; color: black; font-weight: bold;">
        Обновить
      </button>
      <button onclick="this.parentElement.parentElement.remove()" style="margin-left: 10px; 
                background: transparent; border: 1px solid white; color: white; padding: 5px 10px; 
                border-radius: 3px; cursor: pointer;">×</button>
    </div>
  `;
  document.body.appendChild(updateBar);

  // Обработчик кнопки обновить
  document.getElementById('sw-update-btn').onclick = () => {
    if (registration.waiting) {
      // Посылаем сигнал воркеру пропустить ожидание
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    location.reload();
  };
}
// --- КОНЕЦ БЛОКА SERVICE WORKER ---

Vue.use(Router)
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(VueLocalizer)
Vue.component('mc-wysiwyg', McWysiwyg);

Vue.config.productionTip = false;
Vue.config.devtools = false;

window.addEventListener('unhandledrejection', event => {
  if (event.reason && event.reason.response && event.reason.response.status === 401) {
    event.preventDefault();
  }
});

const router = new Router({
  routes: [
    { path: '/', component: Home, },
    { path: '/mail', name: 'mail', component: Mail, },
    { path: '/mail/item', name: 'mailItem', component: MailItem, },
    { path: '/aproposals', component: Aproposals, },
    { path: '/aproposal/:id', component: EditAproposalItem },
    { path: "/contact", component: ContactHR, meta: { noCache: true } },
    { path: '/lunch', component: Lunch, },
    { path: '/timesheets', component: Timesheets, },    
    { path: '/timesheet/:id', component: EditTimesheetItem },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.noCache) {
    to.meta.timestamp = new Date().getTime()
  }
  next()
})

// Хелперы для Cookies
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  document.cookie = cname + "=" + cvalue + ";expires="+d.toUTCString() + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return null;
}

var localizer = new VueLocalizer()
var initLang = getCookie("Lang")
if (initLang) localizer.change(initLang) 

const store = new Vuex.Store({
  state: {
    userInfo: { loggedIn: -1, userName: null },
    cookieOK: null,
    messages: { count: -1 },
    optionsloaded: false,
    options: { timesheets: null, lunches: null, messagesfromspv: null }
  },
  actions: {
    updateUserInfo(context, forceReload = false) {
      const timestamp = forceReload ? `?_t=${new Date().getTime()}` : '';
      const config = {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      };

      axios.get(`/api/logininfo${timestamp}`, config)
      .then(resp => {
        context.commit('setUserInfo', resp.data)
      }).catch(() => {
        context.commit('clearUserInfo')
      })
      
      if (!this.state.optionsloaded || forceReload) {
        axios.get(`/api/GetOptions${timestamp}`, config)
        .then(resp => {
          context.commit('setOptions', resp.data)
          this.state.optionsloaded = true
        })
        .catch(() => {
          console.log('API server not available (development mode)');
        })
      }
    },
    updateMessages(context) {
      axios.get("/api/GetMessagesCount").then(resp => {
        context.commit('setMessagesCount', resp.data)
      })
    },
    logout(context) {
      axios.post("/api/logout")
      context.commit('clearUserInfo')
      router.push('/')
    },
    changeLang(context, newlang){
      localizer.change(newlang)
      setCookie("Lang", newlang, 365)
    },
    setCookieOK(context){
      setCookie("CookieOK", 1, 365)
      context.commit('setCookieOK')
    },
  },
  mutations: {
    setUserInfo (state, data) {
      state.userInfo = {
        loggedIn: data.loggedin,
        userName: data.username,
        messagesCount: data.messagescount
      }
    },
    clearUserInfo(state){
      state.userInfo = { loggedIn: 0, userName: null, messagesCount: null }
    },
    setMessagesCount(state, count) { state.messages.count = count; },
    setCookieOK(state) { state.cookieOK = 1; },
    setOptions(state, options) { state.options = options; }
  }
})

if (getCookie("CookieOK")) {
  store.state.cookieOK = 1;
}

const IE11RouterFix = {
  methods: {
      hashChangeHandler: function() { this.$router.push(window.location.hash.substring(1)); },
      isIE11: function() { return !!window.MSInputMethodContext && !!document.documentMode; }
  },
  mounted: function() { if (this.isIE11()) window.addEventListener('hashchange', this.hashChangeHandler); },
  destroyed: function() { if (this.isIE11()) window.removeEventListener('hashchange', this.hashChangeHandler); }
};

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  localizer,
  mixins: [IE11RouterFix],
})


// WEBPACK FOOTER //
// ./src/main.js